<template>
  <FileInput
    :label="label"
    :attachments="attachments"
    :input-class="`ul-attachment_form_part`"
    :identifier="identifier"
    @addAttachment="attachment => addAttachment(attachment)"
    @deleteAttachment="attachment => deleteAttachment(attachment)"
    @click="$emit('click')"
    @attachment_downloaded="$emit('attachment_downloaded')"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  name: 'Attachments',
  props: {
    label: {
      type: String,
      default: null
    },
    identifier: {
      type: [String, Number],
      required: false
    }
  },
  computed: {
    ...mapGetters({
      attachments: 'forms/attachments/attachments'
    })
  },
  methods: {
    ...mapMutations({
      addAttachment: 'forms/attachments/addAttachment',
      deleteAttachment: 'forms/attachments/deleteAttachment'
    })
  }
};
</script>
